<template>
  <BModal
    title="افزودن نظر به تاریخچه جلسات"
    id="add-comment-to-history"
    centered
    ok-title="ثبت"
    cancel-title="بستن"
    ok-variant="success"
    no-close-on-backdrop
    no-close-on-ok
    @ok.prevent="createNewScheduleHistory"
  >
    <BContainer fluid>
      <BFormRow>
        <BCol cols="12">
          <IndependentLessonPicker
            :isMultiple="false"
            :closeOnSelect="true"
            @getLesson="setLesson"
          ></IndependentLessonPicker>
        </BCol>

        <!-- DSD-669 -->

        <!-- <BCol cols="12">
          <QuestionPicker
            inputLabel="انتخاب نمونه سوالاتی که زبان آموز با مشکل مواجه بوده است"
            :selectedLessonId="scheduleHistoryPayload.lessonId"
            @getQuestions="setQuestions"
          >
          </QuestionPicker>
        </BCol> -->
        <BCol cols="12">
          <CustomEditor
            label="توضیحات جلسه"
            id="desc"
            :hasModules="false"
            v-model="scheduleHistoryPayload.description"
          ></CustomEditor>
        </BCol>

        <!-- DSD-669 -->

        <!-- <BCol cols="12">
          <CustomAudioRecorder
            @getAudioFile="setAudioFile"
          ></CustomAudioRecorder>
        </BCol> -->
        <BCol cols="12">
          <small>وضعیت جلسه </small>
          <div
            style="margin-top: 2px"
            class="w-100 d-flex align-items-center justify-content-center"
          >
            <BButton
              :variant="hasPassed ? 'success' : ''"
              class="w-50 mr-1"
              @click="setIsPassedState(true)"
            >
              <FeatherIcon icon="CheckIcon" size="26" />
            </BButton>
            <BButton
              variant="danger"
              class="w-50"
              :variant="hasPassed == false ? 'danger' : ''"
              @click="setIsPassedState(false)"
            >
              <FeatherIcon icon="XIcon" size="26" />
            </BButton>
          </div>
        </BCol>
      </BFormRow>
    </BContainer>
  </BModal>
</template>

<script>
export default {
  emits: ["reFetch"],
  props: {
    studentUserId: {
      type: [String, Number],
      required: true,
    },
    priceCategoryId: {
      type: [String, Number],
      required: false,
    },
  },
  watch: {
    studentUserId: {
      immediate: true,
      handler(val) {
        this.scheduleHistoryPayload.studentUserId = val;
      },
    },
  },
  data() {
    return {
      isLoading: false,
      scheduleHistoryPayload: {
        masterStudentLessonViewId: 0,
        lessonId: null,
        studentUserId: null,
        description: null,
        isPass: null,
        priceCateogryId: null,
        voiceFile: null,
      },
    };
  },
  methods: {
    async createNewScheduleHistory() {
      try {
        this.scheduleHistoryPayload.studentUserId = this.studentUserId;
        this.scheduleHistoryPayload.priceCateogryId = this.priceCategoryId;
        this.isLoading = true;
        let _this = this;
        let createMasterScheduleLesson = new CreateMasterScheduleLesson(_this);
        createMasterScheduleLesson.setFormData(
          helper.generateFormData(_this.scheduleHistoryPayload)
        );
        await createMasterScheduleLesson.sendFormData((res) => {
          if (res.data.isSuccess) {
            _this.$toast({
              component: ToastificationContent,
              props: {
                title: "اضافه شد",
                icon: "CheckIcon",
                variant: "success",
                text: "نظر شما افزوده شد",
              },
            });
            _this.$emit("reFetch");
          } else {
            _this.$toast({
              component: ToastificationContent,
              props: {
                title: "مشکلی پیش آمد!",
                icon: "XIcon",
                variant: "danger",
                text:
                  res.data.errors || "مشکلی پیش آمد، لطفا دوباره امتحان کنید",
              },
            });
          }
        });
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },
    setQuestions(questions) {
      this.scheduleHistoryPayload.questionIds = [];
      if (questions && questions.length) {
        this.scheduleHistoryPayload.questionIds = questions.map((item) => {
          return item.questionId;
        });
      }
    },
    setAudioFile(audioFile) {
      this.scheduleHistoryPayload.voiceFile = audioFile;
    },
    setIsPassedState(bool) {
      this.scheduleHistoryPayload.isPass = bool;
    },
    setLesson(lessonId) {
      this.scheduleHistoryPayload.lessonId = lessonId;
    },
  },
  computed: {
    hasPassed() {
      return this.scheduleHistoryPayload.isPass;
    },
  },
  components: {
    BModal,
    BContainer,
    BCol,
    BFormRow,
    BFormGroup,
    BFormTextarea,
    BButton,
    IndependentLessonPicker,
    CustomEditor,
    CustomAudioRecorder,
    QuestionPicker,
  },
};
import {
  BModal,
  BContainer,
  BCol,
  BFormRow,
  BFormGroup,
  BFormTextarea,
  BButton,
} from "bootstrap-vue";
import CustomEditor from "@/views/components/Utils/CustomEditor.vue";
import IndependentLessonPicker from "@/views/components/Lessons/IndependentLessonPicker.vue";
import CustomAudioRecorder from "@/views/components/Utils/CustomAudioRecorder.vue";
import QuestionPicker from "@/views/components/Questions/QuestionPicker.vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import { CreateMasterScheduleLesson } from "@/libs/Api/MasterStudentLessonView";
import helper from "@/libs/Helper";
</script>
